import classNames from "classnames";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {NavBarProfileButtonContent} from "@/components/navBar/subComponents/NavbarProfileButtonContent/NavBarProfileButtonContent.tsx";

interface NavBarProfileButtonMobileMobile {
  showMobileProfile: boolean;
  setShowMobileProfile: (show: boolean) => void;
}

export const NavBarProfileButtonMobile = ({
  showMobileProfile,
  setShowMobileProfile,
}: NavBarProfileButtonMobileMobile) => {
  const {user} = useCurrentUserContext();

  if (!user) return null;

  return (
    <div className="mt-auto">
      <Button
        variant={"profileNavButton"}
        className={classNames("w-100", {active: showMobileProfile})}
        onClick={() => setShowMobileProfile(true)}
      >
        <NavBarProfileButtonContent user={user} show={showMobileProfile} />
      </Button>
    </div>
  );
};
